import { FixedAmountCoupon } from "../models/coupons/fixed-amount";
import { DollarAmountOffCoupon } from "../models/coupons/amount-off/dollar-amount-off";
import { PercentAmountOffCoupon } from "../models/coupons/amount-off/percent-amount-off";
import { MixAndMatchPriceCoupon } from "../models/coupons/mix-and-match/mix-and-match-price";
import { MixAndMatchPercentageCoupon } from "../models/coupons/mix-and-match/mix-and-match-percentage";
import { QuantityPriceCoupon } from "../models/coupons/mix-and-match/quantity-price";
import { QuantityDiscountCoupon } from "../models/coupons/mix-and-match/quantity-discount";
import { PercentAmountOffBasedOnPriceCoupon } from "../models/coupons/amount-off/percent-amount-off-based-on-price";
import { PercentAmountOffEntireOrderCoupon } from "../models/coupons/amount-off/percent-amount-off-entire-order";
import { PercentOffAnItemInCategoryCoupon } from "../models/coupons/amount-off/percent-off-an-item-in-category";
import { PercentOffAllItemsInCategoryCoupon } from "../models/coupons/amount-off/percent-off-all-items-in-category";
import { UpgradeCoupon } from "../models/coupons/upgrade";
export class CouponFactory {
    static createCoupon(appType, sourceData, deps, couponData, identity) {
        switch (couponData.couponTypeId) {
            case 20 /* CouponType.FIXED_PRICE */:
                return new FixedAmountCoupon(appType, sourceData, deps, couponData, identity);
            case 10 /* CouponType.DOLLAR_OFF */:
                return new DollarAmountOffCoupon(appType, sourceData, deps, couponData, identity);
            case 31 /* CouponType.PERCENTAGE_OFF_AN_ITEM */:
                return new PercentAmountOffCoupon(appType, sourceData, deps, couponData, identity);
            case 32 /* CouponType.PERCENTAGE_OFF_AN_ITEM_IN_CATEGORY */:
                return new PercentOffAnItemInCategoryCoupon(appType, sourceData, deps, couponData, identity);
            case 33 /* CouponType.PERCENTAGE_OFF_ALL_ITEMS_IN_CATEGORY */:
                return new PercentOffAllItemsInCategoryCoupon(appType, sourceData, deps, couponData, identity);
            case 35 /* CouponType.PERCENTAGE_OFF_ITEM_BASED_ON_PRICE */:
                return new PercentAmountOffBasedOnPriceCoupon(appType, sourceData, deps, couponData, identity);
            case 52 /* CouponType.MIX_AND_MATCH_PRICE */:
                return new MixAndMatchPriceCoupon(appType, sourceData, deps, couponData, identity, couponData.minimumItemQuantity ?? null);
            case 53 /* CouponType.MIX_AND_MATCH_PERCENTAGE */:
                return new MixAndMatchPercentageCoupon(appType, sourceData, deps, couponData, identity, couponData.minimumItemQuantity ?? null);
            case 40 /* CouponType.UPGRADE */:
                return new UpgradeCoupon(appType, sourceData, deps, couponData, identity);
            case 30 /* CouponType.PERCENTAGE_OFF_ENTIRE_ORDER */:
                return new PercentAmountOffEntireOrderCoupon(appType, sourceData, deps, couponData, identity);
            case 50 /* CouponType.QUANTITY_PRICE */:
                return new QuantityPriceCoupon(appType, sourceData, deps, couponData, identity);
            case 51 /* CouponType.QUANTITY_DISCOUNT */:
                return new QuantityDiscountCoupon(appType, sourceData, deps, couponData, identity);
            default:
                return null;
        }
    }
}
//# sourceMappingURL=coupon-factory.js.map